module.exports = __webpack_public_path__ + "img/citizencard.c366b70a.jpg";